module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Published by Akashic Books")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Originally published in 1968 by William Morrow & Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Copyright © 1959, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 2010 by LeRoi Jones/Amiri Baraka")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("ePUB ISBN 13: 978-1-936-07072-5")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN-13: 978-1-933354-93-4")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Library of Congress Control Number: 2009923185")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or utilized in any form or by any means, electronic or mechanical, including photocopying, recording or by any information storage and retrieval system, without permission in writing from the Publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Some of the essays in the volume were originally published in an earlier form in the following publications:")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('i', [_vm._v("Jazz Review")]), _vm._v(", “Introducing Wayne Shorter” (1959)")]), _vm._v(" "), _c('p', {
    staticClass: "hanga1"
  }, [_c('i', [_vm._v("Metronome")]), _vm._v(", “The Jazz Avant-Garde” (1961), “A Jazz Great: John Coltrane” (1963)")]), _vm._v(" "), _c('p', {
    staticClass: "hanga1"
  }, [_vm._v("Billie Holiday liner notes, “The Dark Lady of the Sonnets” (1962)")]), _vm._v(" "), _c('p', {
    staticClass: "hanga1"
  }, [_c('i', [_vm._v("Kulchur")]), _vm._v(", “Introducing Bobby Bradford” (1962), “Present Perfect (Cecil Taylor)” (1962), “Cecil Taylor (The World of Cecil Taylor)” (1962), “Sonny Rollins (Our Man in Jazz)” (1964)")]), _vm._v(" "), _c('p', {
    staticClass: "hanga1"
  }, [_c('i', [_vm._v("Down Beat")]), _vm._v(", “Jazz and the White Critic” (1963), “Recent Monk” (1963), “A Day with Roy Haynes” (1963), “New York Loft and Coffee Shop Jazz” (1963), “Don Cherry” (1963), “Apple Cores #1” (1964), “Apple Cores #2” (1965), “New Tenor Archie Shepp Talking” (1965), “Apple Cores #3” (1966), “Apple Cores #4” (1966), “Apple Cores #5—The Burton Greene Affair” (1966), “Apple Cores #6” (1966)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('i', [_vm._v("Negro Digest")]), _vm._v(", “Three Ways to Play the Saxophone” (1963)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("John Coltrane liner notes, “Coltrane Live at Birdland” (1964)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Archie Shepp liner notes, “Four for Trane” (1965)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('i', [_vm._v("New Wave in Jazz")]), _vm._v(" liner notes, “New Black Music” (1965)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Sonny Murray liner notes, “Sonny’s Time Now” (1967)")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("AkashiClassics: Renegade Reprint Series")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("c/o Akashic Books")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("PO Box 1456")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("New York, NY 10009")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("info@akashicbooks.com")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.akashicbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.akashicbooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237d719c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c5.vue
// module id = 69
// module chunks = 0